var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-in","appear":""}},[_c('div',{staticClass:"selection-panel"},[_c('div',{staticClass:"logo-container"},[_c('img',{staticClass:"logo",attrs:{"src":require("../assets/images/ccp-logo.svg"),"alt":"The Capital of Card Payments logo"}})]),_vm._v(" "),_c('category-dropdown'),_vm._v(" "),_c('location-listing')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2309892c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SelectionPanel.vue
// module id = null
// module chunks = 